<template>
  <section id="products" class="products section">
    <div class="container">
      <div class="section-header">
        <span class="section-label">核心产品</span>
        <h2 class="section-title">核心产品与解决方案</h2>
        <p class="section-desc">
          围绕政务管理全场景，打造五大核心产品矩阵，为政府数字化转型提供坚实底座。
        </p>
      </div>

      <div class="products__grid">
        <component
          :is="product.route ? 'router-link' : 'a'"
          v-for="product in products"
          :key="product.id"
          :to="product.route || undefined"
          :href="product.route ? undefined : '#contact'"
          class="products__card"
        >
          <div class="products__icon" :style="{ background: product.color + '18', color: product.color }">
            {{ product.icon }}
          </div>
          <h3 class="products__title">{{ product.title }}</h3>
          <p class="products__desc">{{ product.desc }}</p>
          <span class="products__link" :style="{ color: product.color }">
            了解详情 →
          </span>
        </component>
      </div>
    </div>
  </section>
</template>

<script>
import { products } from '../data/site'

export default {
  name: 'ProductSection',
  data() {
    return { products }
  }
}
</script>

<style scoped>
.products {
  background: #f7f9fc;
}

.products__grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 24px;
}

.products__card {
  background: #fff;
  border-radius: var(--radius-md, 12px);
  padding: 32px 24px;
  border: 1px solid var(--color-border, #eef1f6);
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

.products__card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, var(--color-primary, #0052d9), var(--color-primary-light, #00a3ff));
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.35s ease;
}

.products__card:hover::before {
  transform: scaleX(1);
}

.products__card:hover {
  box-shadow: var(--shadow-lg, 0 16px 48px rgba(0, 82, 217, 0.12));
  transform: translateY(-6px);
  border-color: rgba(0, 82, 217, 0.15);
}

.products__icon {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin-bottom: 20px;
}

.products__title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 12px;
}

.products__desc {
  font-size: 14px;
  color: #666;
  line-height: 1.7;
  flex: 1;
  margin-bottom: 20px;
}

.products__link {
  font-size: 14px;
  font-weight: 600;
}

@media (max-width: 1200px) {
  .products__grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 960px) {
  .products__grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 560px) {
  .products__grid {
    grid-template-columns: 1fr;
  }
}
</style>
